var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeechIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33333 2C5.70152 2 6 2.29848 6 2.66667V13.3333C6 13.7015 5.70152 14 5.33333 14C4.96515 14 4.66667 13.7015 4.66667 13.3333V2.66667C4.66667 2.29848 4.96515 2 5.33333 2ZM10.6667 3.33333C11.0349 3.33333 11.3333 3.63181 11.3333 4V12C11.3333 12.3682 11.0349 12.6667 10.6667 12.6667C10.2985 12.6667 10 12.3682 10 12V4C10 3.63181 10.2985 3.33333 10.6667 3.33333ZM8 4.66667C8.3682 4.66667 8.66667 4.96515 8.66667 5.33333V10.6667C8.66667 11.0349 8.3682 11.3333 8 11.3333C7.6318 11.3333 7.33333 11.0349 7.33333 10.6667V5.33333C7.33333 4.96515 7.6318 4.66667 8 4.66667ZM2.66667 6C3.03485 6 3.33333 6.29848 3.33333 6.66667V9.33333C3.33333 9.70153 3.03485 10 2.66667 10C2.29848 10 2 9.70153 2 9.33333V6.66667C2 6.29848 2.29848 6 2.66667 6ZM13.3333 6C13.7015 6 14 6.29848 14 6.66667V9.33333C14 9.70153 13.7015 10 13.3333 10C12.9651 10 12.6667 9.70153 12.6667 9.33333V6.66667C12.6667 6.29848 12.9651 6 13.3333 6Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechIcon);
export default __webpack_public_path__ + "static/media/speechIcon.f719dd6d127ede29451020ec8b98eedc.svg";
export { ForwardRef as ReactComponent };